module.exports = __webpack_public_path__ + "img/icon_flag_nl.516864ac.svg";